import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timeIndication"]
  connect() {
    try {
      this.toggleFields()
    } catch (error) {
      console.error("Error in toggleFields:", error)
    }

    try {
      this.toggleFinanceLeaseFields()
    } catch (error) {
      console.error("Error in toggleFinanceLeaseFields:", error)
    }

    try {
      this.toggleTimeIndication()
    } catch (error) {
      console.error("Error in toggleTimeIndicationField:", error)
    }
  }

  toggleFieldVisibility(elementId, show) {
    const element = document.getElementById(elementId)
    if (element) {
      if (show) {
        element.classList.remove("hidden")
      } else {
        element.classList.add("hidden")
      }
    }
  }

  toggleInspectionField() {
    this.toggleFieldVisibility("crane-inspection", this.element.checked)
  }

  toggleInsuranceFields() {
    this.toggleFieldVisibility("insurance-fields", this.element.checked)
  }

  // Insurance type select: each deductible wrapper lists the types it belongs to
  // (FleetAdditionalInfo.deductible_insurance_types). A field that already holds a value stays
  // visible, as on the server, so a deductible is never saved without being shown.
  toggleDeductibleFields() {
    const insuranceType = this.element.value

    document.querySelectorAll("[data-deductible-insurance-types]").forEach((field) => {
      const applies = field.dataset.deductibleInsuranceTypes.split(" ").includes(insuranceType)
      const filled = Array.from(field.querySelectorAll("input")).some((input) => input.value !== "")
      field.classList.toggle("hidden", !applies && !filled)
    })
  }

  toggleFinanceField() {
    const isFinanced = this.element.checked
    this.toggleFieldVisibility("finance-field", isFinanced)
    this.toggleFieldVisibility("is_leased_checkbox", !isFinanced)
  }

  toggleLeaseFields() {
    const isLeased = this.element.checked
    this.toggleFieldVisibility("lease_fields", isLeased)
    this.toggleFieldVisibility("is_financed_checkbox", !isLeased)
  }

  // Create form: every wrapper carrying data-fleet-type-scope lists the types it applies to
  // (Fleet::VEHICLE_ONLY_ATTRIBUTES via FleetsHelper#fleet_type_scope). Machines hide the
  // road-vehicle-only fields; nothing is ever hidden for a vehicle. Hidden inputs are also
  // disabled so a date typed before switching to Maschine is not saved invisibly.
  toggleFields() {
    const fleetTypeElement = document.getElementById("fleet_type")
    if (!fleetTypeElement) return
    const selected = fleetTypeElement.value

    document.querySelectorAll("[data-fleet-type-scope]").forEach((field) => {
      const hidden = !field.dataset.fleetTypeScope.split(" ").includes(selected)
      field.classList.toggle("hidden", hidden)
      // Only the record's own fields: Trix keeps its link-dialog inputs disabled (and required).
      field.querySelectorAll('[name^="fleet["]').forEach((input) => {
        input.disabled = hidden
      })
    })
  }

  toggleFinanceLeaseFields() {
    const isFinancedCheckbox = document.getElementById("is_financed_checkbox")
    const isLeasedCheckbox = document.getElementById("is_leased_checkbox")

    let isFinanced = false
    let isLeased = false

    if (isFinancedCheckbox) {
      isFinanced = isFinancedCheckbox.querySelector("input[type='checkbox']").checked
      this.toggleFieldVisibility("finance-field", isFinanced)
      this.toggleFieldVisibility("is_leased_checkbox", !isFinanced)
      this.toggleFieldVisibility("lease_fields", !isFinanced)
    }

    if (isLeasedCheckbox) {
      isLeased = isLeasedCheckbox.querySelector("input[type='checkbox']").checked
      this.toggleFieldVisibility("lease_fields", isLeased)
      this.toggleFieldVisibility("is_financed_checkbox", !isLeased)
      this.toggleFieldVisibility("finance-field", !isLeased)
    }

    if (!isFinanced && !isLeased) {
      this.toggleFieldVisibility("finance-field", false)
      this.toggleFieldVisibility("lease_fields", false)
    }
  }

  toggleTimeIndication() {
    const tireChangeSelect = this.element.querySelector('select[name="fleet[tire_change]"]')
    if (!tireChangeSelect) return
    const tireChange = tireChangeSelect.value
    if (tireChange === "all_season") {
      this.timeIndicationTarget.classList.remove("hidden")
    } else {
      this.timeIndicationTarget.classList.add("hidden")
    }
  }

  handleChange(_event) {
    this.toggleTimeIndication()
  }
}
